import styled from 'styled-components';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';

export const InputSearch = styled(InputBase)`
  display: flex;
  font-family: 'Graphik-Regular';
  font-size: 14px;
  width: 100%;
  padding-left: 20px;
`;
export const PaperCustom = styled(Paper)`
  display: flex;
  height: 50px;
  align-items: center;
  width: 100%;
  border-radius: 30px;
`;
